@if (hasError$ | async) {
  <div class="flex flex-col items-center justify-center gap-y-8">
    <span i18n>Something has gone wrong!</span>
    <button (click)="retry()" i18n matButton="outlined" type="button">Retry</button>
  </div>
}
@if (dataLoading$ | async) {
  <div class="flex flex-col items-center justify-center gap-y-8">
    <mat-spinner></mat-spinner>
  </div>
}
<!-- if the dataSource input is used. It is possible the the hasError$ or loading$ property is === EMPTY. this would
results in an null as output. If the === false check is used this can result into the behavior that the data grid is
never shown. -->
<!-- eslint-disable-next-line @angular-eslint/template/no-negated-async -->
@if (!(hasError$ | async) && !(dataLoading$ | async)) {
  <table class="w-full table-auto">
    @if (header) {
      <thead>
      <tr>
        <th class="py-2" i18n>Label</th>
        <th class="py-2" i18n>Value</th>
      </tr>
      </thead>
    }
    <tbody>
      @for (row of rows$ | async; track $index; let first = $first) {
        @if ((!displayProperties || row.isSubHeader || (row.name && displayProperties.includes(row.name))) && (!hideEmptyProperties || false === (data$ | isEmpty: row.name | async))) {
          @if (row.flip) {
            <tr>
              <td class="py-2" colspan="2">
                <mat-divider></mat-divider>
              </td>
            </tr>
            <tr [attr.data-name]="row.name + '-header'">
              <ng-container *ngTemplateOutlet="row.headerCell?.template ?? defaultHeaderCell; context: { $implicit: row.name }"></ng-container>
            </tr>
            <tr [attr.data-name]="row.name + '-value'">
              @if (row.name) {
                <ng-container [ngTemplateOutlet]="content"></ng-container>
              }
            </tr>
            <tr>
              <td class="py-4" colspan="2">
                <mat-divider></mat-divider>
              </td>
            </tr>
          } @else {
            @if (!first && row.isSubHeader) {
              <tr>
                <td class="py-4" colspan="2">
                  <mat-divider></mat-divider>
                </td>
              </tr>
            }
            <tr [attr.data-name]="row.name" [ngClass]="{ 'sub-header text-2xl': row.isSubHeader }">
              <ng-container *ngTemplateOutlet="row.headerCell?.template ?? defaultHeaderCell; context: { $implicit: row.name }"></ng-container>
              @if (row.name) {
                <ng-container [ngTemplateOutlet]="content"></ng-container>
              }
            </tr>
          }
        }
        <ng-template #content>
          <td [attr.colspan]="row.flip ? 2 : 1" [ngClass]="{ 'h-20': row.editCell?.template && (isEditMode || isFormMode) && false }" class="pl-8 pr-4 w-full py-2">
            @if (row.editCell?.template && (isEditMode || isFormMode)) {
              <ng-container [ngTemplateOutlet]="editMode"></ng-container>
            }
            @if (!row.editCell?.template || (!isEditMode && !isFormMode)) {
              <ng-container [ngTemplateOutlet]="viewMode"></ng-container>
            }
          </td>
          <ng-template #viewMode>
            <ng-container *ngTemplateOutlet="row.cell?.template ?? defaultCell;context: { $implicit: data$ | dataGridValue: row.name | async, data: data$ | async }"></ng-container>
          </ng-template>
          <ng-template #editMode>
            <ng-container *ngTemplateOutlet="row.editCell?.template ?? row.cell?.template ?? defaultCell;context: { $implicit: data$ | dataGridValue: row.name | async, data: data$ | async }"></ng-container>
          </ng-template>
        </ng-template>
      }
    </tbody>
    @if (hasAnyEditCells) {
      <tfoot>
      <tr>
        <td class="py-2" colspan="2">
          @if (isEditMode) {
            <div class="flex flex-col gap-y-6">
              <div class="flex flex-row gap-x-6 items-center justify-start">
                <button (click)="submit()" [disabled]="loading$ | async" color="primary" matButton="filled" type="button">
                <span class="flex flex-row gap-x-6 items-center justify-center">
                  <span i18n>Save</span>
                  @if (loading$ | async) {
                    <mat-spinner color="accent" diameter="15"></mat-spinner>
                  }
                </span>
                </button>
                <button (click)="reset()" [disabled]="loading$ | async" matButton="outlined" type="button">
                  <ng-container i18n>Reset</ng-container>
                </button>
                <button (click)="cancel()" [disabled]="loading$ | async" class="warning-button" matButton="outlined" type="button">
                  <ng-container i18n>Cancel</ng-container>
                </button>
                @if (isDevMode) {
                  <button (click)="logCurrentFormState()" matButton type="button">
                    <ng-container i18n>Current Form State</ng-container>
                  </button>
                }
              </div>

              <ng-template rxapFormSubmitInvalid>
                <mat-error i18n>Ensure all formula fields are valid.</mat-error>
              </ng-template>

              <ng-template let-error rxapFormSubmitFailed>
                <mat-error>{{ error.error?.message ?? error.message }}</mat-error>
              </ng-template>

              <ng-template rxapFormSubmitSuccessful>
                <span i18n>Submit successfully.</span>
              </ng-template>

            </div>
          } @else {
            <button (click)="enableEditMode()" color="primary" matButton="filled" type="button">
              <span class="flex flex-row gap-x-6 items-center justify-center">
                <span i18n>Edit</span>
                @if (loading$ | async) {
                  <mat-spinner color="accent" diameter="15"></mat-spinner>
                }
              </span>
            </button>
          }
        </td>
      </tr>
      </tfoot>
    }
  </table>
}

<ng-template #defaultCell let-value>
  <span>{{ value }}</span>
</ng-template>
<ng-template #defaultHeaderCell let-name>
  <th class="py-2 whitespace-nowrap">{{ name }}</th>
</ng-template>
